import React from 'react';

import Pagination from 'components/Pagination';

const SurveyListPagination = ({ options, onPageChange, loading, classNameWrapper = '' }) => {
  return (
    <div className={`wrapper mt-8 ${classNameWrapper}`}>
      <Pagination
        loading={loading}
        currentPage={options.page}
        totalPages={Math.ceil(options.total / options.page_size) ?? 0}
        onPageChange={onPageChange}
      />
    </div>
  );
};

export default React.memo(SurveyListPagination);
